export const veteransOutlook = [
    {
        value: "1",
        label: "党员",
    },
    {
        value: "2",
        label: "团员",
    },
    {
        value: "3",
        label: "群众",
    },
]

export const isWillingTrain = [
    {
        value: -1,
        label: "",
    },
    {
        value: 0,
        label: "愿意",
    },
    {
        value: 1,
        label: "不愿意",
    }
]